import { useTheme } from "@mui/material/styles"
import { Scale } from "chroma-js"
import React from "react"

import styled from "styled-components"
import { isValidColor } from "../../utils/color"

const LegendListWrap = styled.div``
const List = styled.ul`
  margin: 0;
  padding: 0;
`
const ListItem = styled.li`
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
`
const ListItemStart = styled.div`
  align-items: center;
  display: inline-flex;

  > label {
    margin: auto 0 auto 0.5rem;
  }
`
const ListItemEnd = styled.div`
  display: inline-flex;
  align-items: center;
`
const ColorSwatch = styled.span<{ color: string }>`
  display: inline-flex;
  background: ${({ color }) => color};
  border-radius: 50%;
  width: 16px;
  height: 16px;
`
const Percentage = styled.span<{ bg: string; color: string }>`
  display: inline-flex;
  padding: 1px 3px;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ color }) => color};
  background: ${({ bg }) => bg};
  margin: 0 0.5rem;
  border-radius: 2px;
`

type TLegendListItem = {
  color: string
  label: string
  value: number | string
  percentage?: number
  active?: boolean
}

interface ILegendListProps {
  rows: TLegendListItem[]
  width?: number | string
}

function LegendList({ rows = [], width }: ILegendListProps) {
  const theme = useTheme()

  const numRows = rows.length

  if (!numRows) {
    return <p>Invalid rows</p>
  }

  // what value gets colored green
  const topPercentageDomain = numRows ? 100 / numRows : 100
  const percentageColorScale: Scale = (theme.colorScales
    .warningInverted as Scale).domain([
    topPercentageDomain * 0.3,
    topPercentageDomain
  ])

  return (
    <LegendListWrap style={{ width: width || "100%" }}>
      <List>
        {rows.map(({ color, label, value, percentage = null }, i) => {
          let activeColor = theme.palette.text.primary
          if (color && isValidColor(color)) {
            activeColor = color
          } else if (color && color in theme.palette) {
            activeColor = theme.palette[color].main
          }

          const percColor = percentageColorScale(percentage).alpha(0.4).css()
          const percColorBg = percentageColorScale(percentage).alpha(0.2).css()
          return (
            <ListItem key={`list-item-${i}`}>
              <ListItemStart>
                <ColorSwatch color={activeColor} />
                <label>{label.toUpperCase()}</label>
              </ListItemStart>
              <ListItemEnd>
                {percentage ? (
                  <Percentage color={percColor} bg={percColorBg}>
                    {percentage}%
                  </Percentage>
                ) : (
                  ""
                )}
                <span>{value}</span>
              </ListItemEnd>
            </ListItem>
          )
        })}
      </List>
    </LegendListWrap>
  )
}

export default LegendList
